import { useRef, useCallback } from "react";

const useInfiniteScrollRef = (fetchNextPage, hasNextPage, isFetchingNextPage) => {
  const observerRef = useRef();

  return useCallback(
    (node) => {
      if (isFetchingNextPage) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasNextPage) fetchNextPage();
      });
      if (node) observerRef.current.observe(node);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );
};

export default useInfiniteScrollRef;
